import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CreaServicios from "../Modals/crear/CreaServicios";
import ConsultarServicios from "../Modals/ConsultarServicios";
import Cookies from "universal-cookie";
import { FaTrash } from "react-icons/fa";

function ServiciosSede() {
  const cookie = new Cookies();
  let { id } = useParams();
  const [list, setList] = useState([]);

  // Cargar lista
  const getData = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerComplejidadSede/" +
        id,
    })
      .then((response) => {
        setList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Eliminar complejidad sede
  const handleDelete = async (itemId) => {
    if (window.confirm("¿Seguro que deseas eliminar este registro?")) {
      try {
        await axios({
          method: "delete",
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
          url:
            "https://suadesarrollo.azurewebsites.net/api/EliminarComplejidadSede/" +
            itemId,
          data: {
            TipoAccion: "Eliminación de registro en complejidad de la sede",
            IdUsuario: cookie.get("id"),
          },
        });

        // Refrescar lista después de eliminar
        setList((prev) => prev.filter((item) => item.id !== itemId));
      } catch (error) {
        console.error("Error al eliminar:", error);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="text-center">
      <div className="container-fluid">
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">Servicios</h6>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table
                className="table table-bordered"
                id="dataTable"
                width="100%"
                cellSpacing="0"
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Sede</th>
                    <th>Complejidad</th>

                    {cookie.get("tipo_Usuario") == 2 && <th>Servicios</th>}

                    <th>Consultar Servicios</th>

                    {cookie.get("tipo_Usuario") == 2 && <th>Acciones</th>}
                  </tr>
                </thead>
                <tbody>
                  {list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.sedeId}</td>
                      <td>{item.complejidad}</td>

                      {cookie.get("tipo_Usuario") == 2 && (
                        <td>
                          <CreaServicios
                            sedeId={item.sedeId}
                            complejidad={item.complejidad}
                          />
                        </td>
                      )}

                      <td>
                        <ConsultarServicios
                          sedeId={item.sedeId}
                          complejidad={item.complejidad}
                        />
                      </td>

                      {cookie.get("tipo_Usuario") == 2 && (
                        <td>
                          <button
                            className="btn btn-danger"
                            onClick={() => handleDelete(item.id)}
                          >
                            <FaTrash />
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiciosSede;
